import * as React from "react";
import { SecondaryButton, Toggle } from "@graffer-inc/console-design-kit";
import { useId } from "react-id-generator";
import { useState } from "react";
import { useHistory } from "react-router-dom";
import { ProcedureDetail } from "@graffer-inc/cloud-gov-core";
import {
  ProcedureDetailType,
  ProcedureEntity,
} from "../../../../../application/domain/procedures/procedure-entity";

import { PaymentItemTable } from "./payment-item-table";
import { PaymentSettingInspectorModal } from "./inspector-modal";
import { UpdateButton } from "../update-button";
import { useModal } from "../../../../../utils/custom-hooks";

export const PaymentSetting: React.FC<{
  procedure: ProcedureEntity;
  onDraftUpdate: (draft: ProcedureDetailType) => void;
}> = ({ procedure, onDraftUpdate }) => {
  const history = useHistory();
  const [detail, setDetail] = useState(
    new ProcedureDetail(JSON.parse(JSON.stringify(procedure.draft))),
  );
  const [enablePaymentSetting, setEnablePaymentSetting] = useState(
    !!detail.paymentSetting,
  );
  const onSwitchPaymentSetting = React.useCallback(() => {
    if (!enablePaymentSetting && !detail.paymentSetting) {
      setDetail(
        new ProcedureDetail({
          ...detail,
          paymentSetting: {
            items: undefined,
          },
        }),
      );
    }
    setEnablePaymentSetting(!enablePaymentSetting);
  }, [enablePaymentSetting, detail]);
  const isPaymentSettingValid = React.useMemo<boolean>(
    () => !enablePaymentSetting || detail.isValid(),
    [enablePaymentSetting, detail],
  );
  const [enablePaymentSettingId] = useId();
  const inspectorModal = useModal();
  return (
    <div>
      <div className="columns">
        <div className="column has-text-left is-three-fifths">
          <Toggle
            id={enablePaymentSettingId}
            label={"決済"}
            description={
              "申請時、決済を「必須」にすることができます。設定をオンにすると詳細な計算式が設定できます。\n手続きの公開後には設定できません。"
            }
            checked={enablePaymentSetting}
            onChange={onSwitchPaymentSetting}
            disabled={procedure.isPublished()}
          />
        </div>
        <div className="column has-text-right buttons">
          <SecondaryButton text="金額を検証" onClick={inspectorModal.open} />
          <UpdateButton
            procedure={procedure}
            disabled={!isPaymentSettingValid}
            onClick={() => {
              if (enablePaymentSetting) {
                onDraftUpdate(detail);
              } else {
                onDraftUpdate(
                  new ProcedureDetail({
                    ...detail,
                    paymentSetting: undefined,
                  }),
                );
              }
            }}
          />
        </div>
      </div>
      {enablePaymentSetting && (
        <PaymentItemTable
          formulaEditHref={`${history.location.pathname}?tab=FORM&formTab=FORMULA`}
          formulas={procedure.formulas}
          items={detail.paymentSetting?.items ?? []}
          onChange={(items) => {
            setDetail(
              new ProcedureDetail({
                ...detail,
                paymentSetting: {
                  ...detail.paymentSetting,
                  items,
                },
              }),
            );
          }}
          readonly={procedure.isPublished()}
        />
      )}
      {inspectorModal.isActive && (
        <PaymentSettingInspectorModal
          onClose={inspectorModal.close}
          procedureId={procedure.id}
          procedureDetail={detail}
        />
      )}
    </div>
  );
};
